import { Component, OnInit } from '@angular/core';
import { BoatService } from '../services/boat.service';
import { Router } from '@angular/router';
import { Boat } from '../l_admin/boat.model';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { getBoatImageUrl } from '../utils/image-url.util';

@Component({
  selector: 'app-deluxe-boat',
  templateUrl: './deluxe-boat.component.html',
  styleUrls: ['./deluxe-boat.component.css'],
})
export class DeluxeBoatComponent implements OnInit {
  boats: any[] = [];
  displayedBoats: Boat[] = [];
  filteredBoats: Boat[] = [];
  arrboat: any[] = [];

  displayedImages: any[] = [];
  loading = false;
  error: string | null = null;
  selectedBoat: any | null = null;
  category: string = 'Deluxe Boat';

  currentPage = 1;
  itemsPerPage = 6;

  constructor(
    private apiService: BoatService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadBoats();
  }

  loadBoats(): void {
    this.loading = true;
    this.error = null;

    this.apiService
      .getBoatByKategori('deluxe-boat', 'Boat Charter')
      .pipe(
        catchError((error) => {
          this.error = 'Failed to load boats. Please try again later.';
          console.error('Error loading boats:', error);
          return of({ data: [] });
        }),
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe((response) => {
        if (response && response.data) {
          this.boats = response.data.filter(
            (boat: any) => boat.boat_kategori === this.category,
          );
          this.filteredBoats = [...this.boats];
          this.updateDisplayedBoats();
          this.updateGalleryImages();
          this.preloadCarouselImages(); // <-- Tambahkan ini
        }
      });
  }

  preloadCarouselImages(): void {
    if (typeof window === 'undefined' || !document) return;

    // Ambil gambar pertama dari setiap boat
    this.filteredBoats.forEach((boat) => {
      if (boat.ms_gambarkapals && boat.ms_gambarkapals.length > 0) {
        const firstImage = boat.ms_gambarkapals[0].gambar;
        const url = getBoatImageUrl(firstImage);

        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = url;
        document.head.appendChild(link);
      }
    });
  }

  updateGalleryImages(): void {
    // Collect all images from all boats
    const allImages = this.boats.reduce((acc, boat) => {
      const boatImages = boat.ms_gambarkapals.map((img: any) => ({
        ...img,
        boat_name: boat.nama_kapal,
        boat_kategori: boat.boat_kategori,
        boat: boat,
      }));
      return [...acc, ...boatImages];
    }, []);

    // Randomly select 6 images
    this.displayedImages = this.shuffleArray(allImages).slice(0, 6);
  }

  getImageUrl(image: any): string {
    return getBoatImageUrl(image.gambar);
  }

  private shuffleArray<T>(array: T[]): T[] {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }

  navigateToDetail(slug: string) {
    this.router.navigate(['/detail-boat', slug]);
  }

  loadMore() {
    this.currentPage++;
    this.updateDisplayedBoats();
  }

  private updateDisplayedBoats() {
    const endIndex = this.currentPage * this.itemsPerPage;
    this.displayedBoats = this.filteredBoats.slice(0, endIndex);
    // console.log(this.displayedBoats);
  }
}
